import React, {
    Fragment,
    useEffect,
    useState
} from "react";
import { connect } from "react-redux";
import Async from "react-select/async";
import {
    Button,
    Form,
    FormFeedback,
    FormGroup,
    FormText,
    Input,
    Label
} from "reactstrap";
import {
    changePassword,
    clearTransferDeviceError,
    getAssignableTranferUsersAsyncSelect,
    getSubordinatesUsersAsyncSelect,
    transferDevices,
    transferUsersForm
} from "../../../store/actions";
import { updateForm } from "../../../store/form/actions";
import { getCurrentUserUnassignedDevicesForAsyncSelect } from "../../../store/device/actions";

const TransferUsersForm = (props) => {

    const { handleClose, userId, organisationId, form } = props;
    const [selected_users, setSelectedUsers] = useState("");
    const [selected_Device, setDevice] = useState("");

    const isSelectedDevices = form && form.formTransfer && form.formTransfer.selection === "Selected";

    useEffect(() => {
        props.updateForm({
            formTransfer: {},
            errors: {}
        })
        //--------------------Key-Listener----------------------
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
            props.clearTransferDeviceError();
        }
    }, [])

    const handleLoadUnAssignedDevices = (inputValue, callback) => {
        const { getCurrentUserUnassignedDevicesForAsyncSelect, userId } = props;
        if (userId) {
            return getCurrentUserUnassignedDevicesForAsyncSelect(userId, inputValue, callback);
        }
        else {
            callback([]);
        }
    };

    const handleUnAssignedDeviceChange = (value) => {
        const selected_devices = Array.isArray(value) ? value : [];
        props.updateForm({
            formTransfer: {
                ...form.formTransfer,
                selected_devices: selected_devices,
                errors: {
                    ...form && form.errors,
                    selected_devices: null,
                }
            },
        });
    };

    const handleLoadUsers = (inputValue, callback) => {
        if (userId && organisationId) {
            props.getAssignableTranferUsersAsyncSelect(userId, organisationId, inputValue, callback)
        }
        else {
            callback([]);
        }
    };

    const handleUserChange = (value) => {
        setSelectedUsers(value)
        props.updateForm({
            formTransfer: {
                ...form.formTransfer,
                selected_user: value
            },
            errors: {
                ...form && form.errors,
                selected_user: null,
            }
        });
    };

    const handleSelectOnChange = (event) => {
        const { name, value } = event.target;
        setDevice(value)
        props.updateForm({
            formTransfer: {
                ...form.formTransfer,
                [name]: value
            },
            errors: {
                ...form && form.errors,
                [name]: null,
            }
        });
    };

    const handleTransferUser = (e) => {
        e.preventDefault();
        const { formTransfer } = form || {};
        const { selected_devices, selection, selected_user } = formTransfer || {};
        const currentErrors = {};

        if (!selected_user) {
            currentErrors.selected_user = "Target User is required"
        }
        if (!selection) {
            currentErrors.selection = "Selection is required"
        }
        if (!selected_devices && isSelectedDevices) {
            currentErrors.selected_devices = "Devices is required"
        }

        props.updateForm({
            formTransfer: {
                ...form.formTransfer,
            },
            errors: currentErrors,
        })

        if (Object.keys(currentErrors).length === 0) {
            props.transferDevices(userId, form.formTransfer);
        }
    };

    return (
        <Fragment>
            <Form onSubmit={handleTransferUser}>
                <FormGroup>
                    <Label>
                        Target User<span className="text-danger">*</span>
                    </Label>
                    <Async
                        styles={{
                            control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: (form && form.errors && form.errors.selected_user) ? 'red' : "silver"
                            })
                        }}
                        autoFocus
                        openMenuOnFocus
                        name="select_user"
                        placeholder="Select User"
                        defaultOptions
                        loadOptions={handleLoadUsers}
                        onChange={handleUserChange}
                        isSearchable
                        value={selected_users}
                    />
                    {(form && form.errors && form.errors.selected_user) &&
                        <FormText sx={{ marginLeft: "10px" }}>
                            <div className="text-danger">
                                {form && form.errors && form.errors.selected_user}
                            </div>
                        </FormText>
                    }
                </FormGroup>
                <FormGroup>
                    <Label>
                        Selection<span className="text-danger">*</span>
                    </Label>
                    <Input
                        name="selection"
                        type='select'
                        onChange={handleSelectOnChange}
                        value={selected_Device}
                        invalid={form && form.errors && form.errors.selection}
                    >
                        <option value="">Select</option>
                        <option value="All">All Devices</option>
                        <option value="Selected">Selected Devices</option>
                    </Input>
                    <FormFeedback>
                        {form && form.errors && form.errors.selection}
                    </FormFeedback>
                </FormGroup>
                {isSelectedDevices && (
                    <FormGroup>
                        <Label>
                            Devices<span className="text-danger">*</span>
                        </Label>
                        <Async
                            styles={{
                                control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: (form && form.errors && form.errors.selected_devices) ? 'red' : "silver"
                                })
                            }}
                            name="selected_devices"
                            placeholder="Select Devices"
                            isSearchable
                            isMulti
                            isClearable
                            defaultOptions
                            loadOptions={handleLoadUnAssignedDevices}
                            onChange={handleUnAssignedDeviceChange}
                        />
                        {(form && form.errors && form.errors.selected_devices) &&
                            <FormText sx={{ marginLeft: "10px" }}>
                                <div className="text-danger">
                                    {form && form.errors && form.errors.selected_devices}
                                </div>
                            </FormText>
                        }
                    </FormGroup>
                )}
                <FormGroup>
                    <Button
                        type="submit"
                        className='me-4'
                        color="success"
                        onClick={handleTransferUser}
                    >
                        Submit
                    </Button>
                    <Button
                        color="danger"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                </FormGroup>
            </Form>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    form: state.form.form,
    isPending: state.userdetails.isTransferUserPending,
    errorMessage: state.userdetails.transferErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (transferForm) => dispatch(updateForm(transferForm)),
    transferUsersForm: (transferForm) => dispatch(transferUsersForm(transferForm)),
    changePassword: () => dispatch(changePassword()),
    clearTransferDeviceError: () => dispatch(clearTransferDeviceError()),
    transferDevices: (userId, transferForm) => dispatch(transferDevices(userId, transferForm)),
    getSubordinatesUsersAsyncSelect: (userId, organisationId, searchValue, callback) => dispatch(getSubordinatesUsersAsyncSelect(userId, organisationId, searchValue, callback)),
    getAssignableTranferUsersAsyncSelect: (userId, organisationId, searchValue, callback) => dispatch(getAssignableTranferUsersAsyncSelect(userId, organisationId, searchValue, callback)),
    getCurrentUserUnassignedDevicesForAsyncSelect: (userId, searchValue, callback) => dispatch(getCurrentUserUnassignedDevicesForAsyncSelect(userId, searchValue, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransferUsersForm);
